import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useState, useEffect } from 'react';

function Layout() {
    const [showSidebar, setShowSidebar] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(false);

    // Fechar sidebar quando clicar fora (mobile)
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showSidebar && window.innerWidth <= 991) {
                const sidebar = document.querySelector('.sidebar-modern');
                const header = document.querySelector('.header-traditional');
                
                if (sidebar && !sidebar.contains(event.target) && 
                    header && !header.contains(event.target)) {
                    setShowSidebar(false);
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [showSidebar]);

    return (
        <div className={`layout-container-traditional ${isCollapsed ? 'sidebar-collapsed' : ''}`}>
            <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
            <Sidebar 
                showSidebar={showSidebar} 
                setShowSidebar={setShowSidebar}
                isCollapsed={isCollapsed}
                setIsCollapsed={setIsCollapsed}
            />
            <main className="main-content-with-sidebar">
                <Outlet />
            </main>
        </div>
    );
}

export default Layout; 